{
  "title": "患者引き継ぎ (I-PASS)",
  "illnessSeverity": "重症度",
  "patientSummary": "患者サマリー",
  "actionList": "対応事項リスト",
  "situationAwareness": "状況認識",
  "synthesis": "受け手による要約",
  "acknowledge": "引き継ぎ確認",
  "severity": {
    "stable": "安定",
    "watcher": "要観察",
    "unstable": "不安定"
  },
  "loading": "Loading handoffs…",
  "errorState": "Could not load handoffs.",
  "emptyState": "No handoffs waiting for you.",
  "unknownPatient": "Unknown patient",
  "from": "Handed over by {{name}}",
  "openChart": "Open chart",
  "notProvided": "Not provided",
  "noActions": "No actions listed.",
  "noContingency": "No contingency plan was given. Ask the outgoing clinician what to watch for.",
  "synthesisHint": "Read back what you understood. This is the step the protocol exists to force.",
  "synthesisPlaceholder": "In my own words, the plan is…",
  "acknowledgedAt": "Acknowledged {{when}}",
  "toast": {
    "acknowledged": "Handoff acknowledged",
    "acknowledgeFailed": "Could not acknowledge the handoff"
  },
  "ipass": {
    "illness": "I — Illness severity",
    "patientSummary": "P — Patient summary",
    "actionList": "A — Action list",
    "situationAwareness": "S — Situation awareness",
    "contingencyPlan": "S — Contingency plan",
    "synthesis": "S — Synthesis by receiver"
  }
}
